import api from "../../index.js";

export const GetIBDashboardByIdApi = () => api.get(`IBMaster/IBDashboard-ById`);
export const GetIBOverviewApi = (params) => api.get(`IBMaster/Get-Project-Overview?${params}`);
export const GetMySubIbApi = (params) => api.get(`IBMaster/GetMySubIB?${params}`);
export const GetTeamPerformanceApi = (params) => api.get(`IBMaster/GetMyClient?${params}`);